import { useEffect, useState } from 'react';
import { useNav } from '@/lib/nav';
import routes from '@/lib/routes';
import BillingModal from '@/components/BillingModal';

export default function AccountBillingPage() {
  const [open, setOpen] = useState(true);
  const { go } = useNav();

  useEffect(() => {
    if (!open) {
      // Navigate back to dashboard when the modal closes
      go(routes.dashboard());
    }
  }, [open, go]);

  return (
    <BillingModal open={open} onOpenChange={setOpen} />
  );
}


